<div class="grid-main-grid">
    <ng-content></ng-content>
</div>
